import { Outlet } from "react-router-dom"

export const UserManagementContainer = () => {
    return (
        <Outlet />
    )
}
